import {Label} from "./Label";
import {Address} from "./Address";
import {Phone} from "./Phone";
import {Recurrence} from "./Recurrence";
import { Company } from "./Company";

export class Client {
    constructor({
                    //attributes
                    id= null,
                    company_id= null,
                    external_id= null,
                    name= '',
                    trade= '',
                    email= '',
                    type= 'pf',
                    cpf= '',
                    cnpj= '',
                    uuid= '',
                    origin=null,
                    potential=null,
                    extradata= {obs:'', position:''},
                    birthdate= null,
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                    sync_at= null,
                    //relations
                    contact_people=[],
                    contact_companies=[],
                    contact_type = 0,
                    addresses=[],
                    phones=[],
                    labels=[],
                    offices=[],
                    extra_infos = [],
                    extra_info_values = [],
                    pricing_table = [],
                    recurrences = [],
                    total_spent = 0,
                    opportunity = null,
                    latest_score = null,
                    responsable_id=null,
                    rt_id=null,
                    rt_value=0,
                    rt={},
                    website=null,
                    cau = null,
                    scheduling_whats=[]
                } = {}) {

        //fill attributes

        this.id= id;
        this.website= website;
        this.responsable_id=responsable_id;
        this.company_id=company_id;
        this.external_id=external_id;
        this.name=name;
        this.trade=trade;
        this.email=email;
        this.type=type;
        this.potential=potential;
        this.cpf=cpf;
        this.contact_type=contact_type;
        this.cnpj=cnpj;
        this.uuid=uuid;
        this.origin=origin;
        this.extradata=(extradata && !(Array.isArray(extradata) && !extradata.length)) ? extradata : {obs:'', position:''};
        this.birthdate=birthdate?new Date(birthdate):null;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;
        this.sync_at=sync_at;
        this.cau=cau;

        this.addresses=(addresses || []).map(a=>new Address(a));
        this.phones=(phones || []).map(p => new Phone(p)) ;
        this.labels=labels.map(l=>new Label(l));
        this.offices=offices.map(l=>new Company(l));
        this.contact_people=contact_people.map(c=>new Client(c));
        this.contact_companies=contact_companies.map(c=>new Client(c));
        this.extra_infos=extra_infos;
        this.pricing_table=pricing_table;
        this.latest_score=latest_score;
        //map extrafields to values
        this.extra_info_values = extra_infos.map(field=>{
            let currentValue = extra_info_values.find(fieldValue=>fieldValue.extrainfo_id===field.id) || {}
            return {
                id: currentValue.id || null,
                extrainfo_id: field.id,
                extrainfoanswers_able: currentValue.extrainfoanswers_able ||this.id,
                extrainfoanswers_able_type: currentValue.extrainfoanswers_able_type || "App\\Models\\Client",
                value: currentValue.value || "",
                field: field
            }
        })
        this.recurrences = recurrences.map(r=>new Recurrence(r))
        this.scheduling_whats=scheduling_whats;

        this.total_spent=total_spent;
        this.opportunity=opportunity;
        this.rt_id=rt_id;
        this.rt_value=rt_value;

        this.rt=this.rt_id===0?{'id':0,'name':'RT personalizado'}:rt;
    }

    get phoneNumbers(){
        return this.phones.map(p=>p.phone).join(", ")
    }

    addAddress(){
        this.addresses.push(new Address({}))
    }

    removeAddress(index){
        this.addresses.splice(index, 1)
    }

    addPhone(){
        this.phones.push(new Phone({}))
    }

    removePhone(index){
        this.phones.splice(index, 1);
    }

    isPf(){
        return this.type==='pf';
    }

    isPj(){
        return this.type==='pj';
    }

    hasCompanies(){
        return this.isPf() && this.contact_companies.length > 0;
    }

    hasMultipleCompanies(){
        return this.isPf() && this.contact_companies.length > 1;
    }

    hasContacts(){
        return this.isPj() && this.contact_people.length > 0;
    }

    set obs(value){
        this.extradata.obs = value;
    }

    get obs(){
        if(!this.extradata.obs)
            this.extradata.obs="";
        return this.extradata.obs
    }

    get labelList(){
        return this.labels.map(l=>l.name).join(", ")
    }

    get officeList(){
        return this.offices.map(l=>l.name).join(", ")
    }

    get phoneList(){
        return this.labels.map(l=>l.name).join(", ")
    }

    get contactPeopleNames(){
        return this.contact_people.map(c=>c.name).join(", ")
    }

    get contactCompaniesNames(){
        return this.contact_companies.map(c=>c.name).join(", ")
    }

   createAttribute(key, value){
        this[key] = value;
    }
}

export function createClient(data={}) {
    return Object.freeze(new Client(data));
}